function rgQuietAdd(body) {
  var plain = function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body }).then(function (r) { return r.json(); }); };
  try {
    if (!window.Worker || !window.Blob || !window.URL) return plain();
    return new Promise(function (resolve) {
      var src = "self.onmessage=function(e){fetch(e.data.u,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:e.data.b}).then(function(r){return r.json()}).then(function(j){self.postMessage({ok:1,j:j})}).catch(function(){self.postMessage({ok:0})})}";
      var url = URL.createObjectURL(new Blob([src], { type: 'text/javascript' }));
      var w = new Worker(url), done = false;
      var finish = function (p) { if (done) return; done = true; try { w.terminate(); URL.revokeObjectURL(url); } catch (e) {} resolve(p); };
      var t = setTimeout(function () { finish(plain()); }, 8000);
      w.onmessage = function (m) { clearTimeout(t); finish(m.data && m.data.ok ? m.data.j : plain()); };
      w.onerror = function () { clearTimeout(t); finish(plain()); };
      w.postMessage({ u: location.origin + '/cart/add.js', b: body });
    });
  } catch (e) { return plain(); }
}
if (!customElements.get('rg-priority-row')) {
      customElements.define('rg-priority-row', class extends HTMLElement {
        connectedCallback() {
          /* rg 10-14: let the cart language sync (product templates) finish first, so the two never write the cart at once */
          var self = this, sync = window.__rgCartSync;
          if (sync && sync.then && !this.__rgWaited) { this.__rgWaited = true; var again = function () { if (self.isConnected) self.connectedCallback(); }; sync.then(again, again); return; }
          this.box = this.querySelector('.rg-prio__box');
          this.box.addEventListener('click', () => this.toggle());
          var on = this.dataset.selected === 'true', others = Number(this.dataset.others || 0), otherKey = this.dataset.otherKey || '';
          var optedOut = false; try { optedOut = sessionStorage.getItem('rg_prio_off') === '1'; } catch (e) {}
          if (others === 0) { if (on || otherKey) this.change(false, true); return; }
          /* rg 10-13: one delivery line per cart. A delivery line added on the other language's product page
             (Entrega Prioritaria <-> Priority Delivery) is replaced by this page's version instead of stacking. */
          if (otherKey) { this.change(true, true); return; }
          if (!on && !optedOut) this.change(true, true);
        }
        toggle() {
          var on = this.dataset.selected === 'true';
          try { sessionStorage.setItem('rg_prio_off', on ? '1' : '0'); } catch (e) {}
          this.change(!on, false);
        }
        change(add, silent) {
          if (this.busy) return; var self = this; this.busy = true; this.classList.add('is-busy');
          var sections = 'cart-drawer,cart-icon-bubble';
          /* rg 2026-09-25: the priority line is added from a background worker so Shopify's
             Meta pixel does not count it as a second AddToCart (1 shopper = 1 AddToCart).
             Falls back to a normal fetch if workers are unavailable. */
          var addBody = JSON.stringify({ items: [{ id: Number(this.dataset.variant), quantity: 1 }], sections: sections });
          var ownKey = this.dataset.key || '', otherKey = this.dataset.otherKey || '', isOn = this.dataset.selected === 'true';
          var removeLine = function (key) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0, sections: sections }) }).then(function (r) { return r.json(); }); };
          var req = Promise.resolve(null);
          /* rg 10-17: data-other-key can list several lines (other language, or the $3.95/$2.95 twin); remove each */
          otherKey.split(',').filter(Boolean).forEach(function (k) { req = req.then(function () { return removeLine(k); }); });
          if (add) { if (!isOn) req = req.then(function () { return rgQuietAdd(addBody); }); }
          else if (ownKey) req = req.then(function () { return removeLine(ownKey); });
          req.then(function (state) {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && state && state.sections) {
              var html = state.sections['cart-drawer'];
              var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
              var cur = drawer.querySelector('.drawer__inner');
              if (inner && cur) cur.innerHTML = inner.innerHTML;
              var bubble = document.getElementById('cart-icon-bubble');
              if (bubble && state.sections['cart-icon-bubble']) bubble.innerHTML = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
            }
          }).catch(function () {}).finally(function () { self.busy = false; self.classList.remove('is-busy'); });
        }
      });
    }

/* rg 2026-09-25: cart-drawer upsell tiles (forms product-form-upsell-1/2) add through the same
   quiet path, so Meta's AddToCart stays = the main product only. Main product form untouched. */
function rgRenderDrawer(state) {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer || !state || !state.sections) return;
  var html = state.sections['cart-drawer'];
  var inner = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
  var cur = drawer.querySelector('.drawer__inner');
  if (inner && cur) cur.innerHTML = inner.innerHTML;
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble && state.sections['cart-icon-bubble']) {
    var s = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
    if (s) bubble.innerHTML = s.innerHTML;
  }
}
if (!window.__rgQuietUpsell) {
  window.__rgQuietUpsell = true;
  document.addEventListener('submit', function (e) {
    var f = e.target, fid = f && f.getAttribute ? (f.getAttribute('id') || '') : '';
    if (fid.indexOf('product-form-upsell-') !== 0) return;
    var fd = new FormData(f), id = Number(fd.get('id'));
    if (!id) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('[type="submit"]');
    if (btn) { if (btn.getAttribute('aria-disabled') === 'true') return; btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    var body = JSON.stringify({ items: [{ id: id, quantity: Number(fd.get('quantity') || 1) }], sections: 'cart-drawer,cart-icon-bubble' });
    rgQuietAdd(body).then(function (state) {
      if (state && state.status && state.description) { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } return; }
      rgRenderDrawer(state);
    }).catch(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  }, true);
}
